<div class="space-y-2" [formGroup]="form">
  @if(!configs.noLabel) {
  <p [class]="configs.labelClass ?? ''">{{ configs.inputLabel }}</p>
  }
  <div>
    <mat-form-field
      [appearance]="configs.formFieldType"
      [ngClass]="configs.formFieldType ? mapFormFieldType() : ''"
      [class]="configs.class ?? ''"
      [class.pt-8]="configs.noLabel"
    >
      @if(configs.prefix?.name) {
      <mat-icon
        class="icon"
        [class]="configs.prefix?.class ?? ''"
        matPrefix
        (click)="emitPrefixIconClick()"
      >
        {{ configs.prefix?.name }}
      </mat-icon>
      }
      <input
        matInput
        [type]="configs.inputType"
        [placeholder]="configs.placeholder ?? ''"
        [formControlName]="configs.controlName"
        [mask]="returnCorrectMask()"
        [readonly]="configs.readOnly"
        [class.text-center]="configs.textAlign === 'center'"
        [class.text-right]="configs.textAlign === 'right'"
        (change)="emitInputValue($event)"
        (blur)="emitInputOutOfFocus($event)"
      />
      @if(configs.suffix?.name) {
      <mat-icon
        class="icon"
        [class]="configs.suffix?.class"
        matSuffix
        (click)="emitSuffixIconClick()"
      >
        {{ configs.suffix?.name }}
      </mat-icon>
      }
    </mat-form-field>
    @if(configs.inputValidators) { @for (inputValidator of
    configs.inputValidators.errorMessages; track inputValidator.validatorName) {
    @if(form.get(configs.controlName)?.touched &&
    form.get(configs.controlName)?.invalid &&
    form.get(configs.controlName)?.errors?.[inputValidator.validatorName]) {
    <mat-error>{{ inputValidator.errorMessage }}</mat-error>
    } } }
  </div>
</div>
